export enum AllowedTwoFAEnum {
    None = 0,
    CallAndText = 1,
    Email = 2,
    AuthApp = 4,
    SecurityKey = 8
}
